import { render, staticRenderFns } from "./LogIp.vue?vue&type=template&id=2ca12c20&scoped=true"
import script from "./LogIp.vue?vue&type=script&lang=js"
export * from "./LogIp.vue?vue&type=script&lang=js"
import style0 from "./LogIp.vue?vue&type=style&index=0&id=2ca12c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca12c20",
  null
  
)

export default component.exports